import { DropdownOption } from "@dbn/omnichannel-design-system-g4p";
import { option, record } from "fp-ts";
import { Option } from "fp-ts/Option";
import { constant, pipe } from "fp-ts/function";
import { MaternityParentalLeaveProps, useFormatAllowanceType } from "../domain";
import { useFormatMessage } from "../../../intl";
import * as api from "../api";
import { DropdownField } from "../../../Common/DropdownField/DropdownField";
import {
  dropdownOptionToValue,
  selectedDropdownOption,
} from "../../../Common/selectDropdownOption";
import { ReadOnlyFieldToValue } from "../../../Common/ReadOnlyField/ReadOnlyFieldToValue";

export function AllowanceTypeDropdown({
  fieldProps,
}: MaternityParentalLeaveProps) {
  const formatMessage = useFormatMessage();
  const formatEmploymentType = useFormatAllowanceType();

  const dropdownOptions: Array<DropdownOption<api.AllowanceType>> = pipe(
    api.AllowanceType.keys,
    record.collect(employmentType => ({
      value: employmentType,
      label: formatEmploymentType(employmentType),
    }))
  );

  const onChange = (
    dropdownOption: Option<DropdownOption<api.AllowanceType>>
  ) => {
    fieldProps.onChange(dropdownOptionToValue(dropdownOption));
  };

  const value = selectedDropdownOption(fieldProps.value, dropdownOptions);

  return fieldProps.disabled ? (
    <ReadOnlyFieldToValue
      value={pipe(
        value,
        option.map(({ label }) => String(label)),
        option.getOrElse(constant(""))
      )}
      label={formatMessage("StandardLoan.allowanceType")}
    />
  ) : (
    <DropdownField
      {...fieldProps}
      clearable={false}
      label={formatMessage("StandardLoan.allowanceType")}
      onChange={onChange}
      options={dropdownOptions}
      placeholder={formatMessage("StandardLoan.allowanceTypePlaceholder")}
      searchable={false}
      value={value}
    />
  );
}
